import React, { useContext, useMemo } from 'react';
import { retrieveSchema } from 'react-jsonschema-form/lib/utils';
import CompareContext from './RecordCompareContext';
import { Column, Row } from '../Layout/RecordCompareLayout';
import mergeRecords from '../../util/recordCompareMergeRecords';
import MetaData from '../MetaData/RecordCompareMetaData';
import useCompareRecordsMetadata from '../../hooks/useCompareRecordsMetadata';
import filterLayoutToVisibleFromSchema from '../../util/recordCompareFilterLayoutToVisibleFromSchema';
import filterLayoutToVisibleFromRecords from '../../util/recordCompareFilterLayoutToVisibleFromRecords';
import RecordCompareStateContext from '../../RecordCompareStateContext';
import { getRecordWithLongestUiSchema } from '../../util/recordCompareRecordObject';
import DMLayoutGroup from '../DMLayoutGroup/DMLayoutGroup';
export default function RecordObject() {
  var _useContext = useContext(RecordCompareStateContext),
    records = _useContext.records,
    master = _useContext.master,
    selections = _useContext.selections,
    cardView = _useContext.cardView;
  var fileMetadata = useCompareRecordsMetadata();
  var _getRecordWithLongest = getRecordWithLongestUiSchema(records),
    uiSchema = _getRecordWithLongest.uiSchema,
    schema = _getRecordWithLongest.schema;
  var mergeData = useMemo(function () {
    return mergeRecords(records, master, selections);
  }, [records, master, selections]);
  var mergedRecords = useMemo(function () {
    return records.map(function (record) {
      var schema = record.schema,
        uiSchema = record.uiSchema,
        data = record.data;
      var layout = uiSchema['dm:layout'];
      var rSchema = retrieveSchema(schema, schema, data);
      return Object.assign({}, record, {
        layout: filterLayoutToVisibleFromSchema(layout, rSchema),
        schema: rSchema
      });
    });
  }, [records]);
  var mergeRecord = useMemo(function () {
    var rSchema = retrieveSchema(schema, schema, mergeData);
    return {
      data: mergeData,
      layout: filterLayoutToVisibleFromSchema(uiSchema['dm:layout'], rSchema),
      // The "merge" layout - only fields that will be visible in the final record based on dependent fields
      schema: rSchema,
      uiSchema: uiSchema
    };
  }, [schema, mergeData, uiSchema]);
  var definitions = useMemo(function () {
    return records.reduce(function (acc, record) {
      var definitions = record.schema.definitions;
      if (definitions) {
        Object.keys(definitions).forEach(function (key) {
          acc["#/definitions/".concat(key)] = Object.assign({}, definitions[key]);
        });
      }
      return acc;
    }, {});
  }, [records]);
  var layout = useMemo(function () {
    return filterLayoutToVisibleFromRecords(uiSchema['dm:layout'], mergedRecords);
  }, [uiSchema, mergedRecords]);
  var compareContext = useMemo(function () {
    return {
      definitions: definitions,
      fileMetadata: fileMetadata,
      isSelectable: true,
      // Not selectable when hidden due to dependent fields
      propertyPrefix: '',
      mergeRecord: mergeRecord,
      records: mergedRecords,
      // Layout that has every field visible from any record
      layout: layout
    };
  }, [definitions, fileMetadata, mergedRecords, mergeRecord, layout]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CompareContext.Provider, {
    value: compareContext
  }, /*#__PURE__*/React.createElement(DMLayoutGroup, null)), !cardView && /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Column, null), records.map(function (record, index) {
    return /*#__PURE__*/React.createElement(Column, {
      key: "metadata-".concat(record.id)
    }, /*#__PURE__*/React.createElement(MetaData, {
      record: record,
      index: index
    }));
  })));
}